<template>
  <div>
    <nav id="nav-menu" class="fixed-bottom py-0 d-flex justify-content-around mt-2">
     <!--  <div
        :style="mtdGetStyle('permiso_caja')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('permiso_caja')"
      >
        <span :style="mtdGetStyleSpan('permiso_caja')" class="btn w-100"
          ><strong>PERMISOS DE CAJA</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('permiso_anulacion')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('permiso_anulacion')"
      >
        <span :style="mtdGetStyleSpan('permiso_anulacion')" class="btn w-100"
          ><strong>PERMISOS DE ANULACIÓN</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('permiso_os')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('permiso_os')"
      >
        <span :style="mtdGetStyleSpan('permiso_os')" class="btn w-100"
          ><strong>PERMISO DE LOGISTICA</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('reporte_caja')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('reporte_caja')"
      >
        <span :style="mtdGetStyleSpan('reporte_caja')" class="btn w-100"
          ><strong>REPORTES DE CAJA</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('inreso_egreso')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('inreso_egreso')"
      >
        <span :style="mtdGetStyleSpan('inreso_egreso')" class="btn w-100"
          ><strong>REPORTES DE INGRESOS/EGRESOS</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('consultas')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('consultas')"
      >
        <span :style="mtdGetStyleSpan('consultas')" class="btn w-100"
          ><strong>CONSULTAR DOCUMENTO</strong></span
        >
      </div> -->
      <div
        :style="mtdGetStyle('work')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('work')"
      >
        <span :style="mtdGetStyleSpan('work')" class="btn w-100"
          ><strong>ORDEN DE TRABAJO</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('options')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('options')"
      >
        <span :style="mtdGetStyleSpan('options')" class="btn w-100"
          ><strong>PERMISOS</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('reports')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('reports')"
      >
        <span :style="mtdGetStyleSpan('reports')" class="btn w-100"
          ><strong>REPORTES</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('consultas')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('consultas')"
      >
        <span :style="mtdGetStyleSpan('consultas')" class="btn w-100"
          ><strong>CONSULTAR DOCUMENTO</strong></span
        >
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "FooterGerenciaComponent",
  props: {
    pageView: String,
  },
  data() {
    return {
      page: null,
    };
  },
  created() {},
  methods: {
    mtdGetStyle: function (option) {
      if (option == this.page && this.pageView != "home") return "background: #43517A";
      return "";
    },
    mtdGetStyleSpan: function (option) {
      if (option == this.page && this.pageView != "home") return "color:white";
      return "";
    },
    mtdSendOption: function (page) {
      this.page = page;
      this.$emit("mtdChangePage", this.page);
    },
  },
};
</script>
